export default function ScrollReveal({ children, className = '' }) {
  return (
    <div className={className}>
      {children}
    </div>
  );
}
